import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_projetos'])) {
            can('manage', 'PROJETO')
            can('adicionar_cliente', 'PROJETO_FABRICA')
        }
        if (user.temPermissao(['projetista', 'site_manager'])) {
            can(['read', 'readInterno'], 'PROJETO');
        }
        if (user.temPermissao(['editor_projetista'])) {
            can(['read', 'readInterno', 'create', 'update', 'upload'], 'PROJETO');
        }
        if (user.temPermissao(['site_manager'])) {
            can(['upload'], 'PROJETO');
        }
    }

    return build()
}